export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M6 19h4V5H6zm8-14v14h4V5z\"/>"
};